// extracted by mini-css-extract-plugin
module.exports = {"layout":"profile-card_layout__PPcEP","photo":"profile-card_photo__fVIGY"};